import styles from './UnloggedHeader.module.css'
import logo_zr from '../assets/img/logoZR.png'
import logo_nb from '../assets/img/logoNB.png'
import logo_dl from '../assets/img/logoDL.png'

export default function UnloggedHeader({link = "/login"}) {
    return (
        <header className={[styles.header, styles.transparent].join(' ')}>
            <div className={[styles.flexRow, styles.alignCenter, styles.justifyRight, styles.showOnMobile].join(' ')}>
                <a href={link} className={[styles.logo].join(' ')}>
                    <div className={[styles.flexRow, styles.alignCenter].join(' ')}>
                        <img src={logo_zr} alt=""></img>
                        <img src={logo_nb} alt=""></img>
                        <img src={logo_dl} alt=""></img>
                    </div>
                </a>
            </div>
            <div className={[styles.container, styles.flexRow, styles.alignCenter, styles.justifyRight, styles.showOnDesktop].join(' ')}>
                <a href={link} className={[styles.logo].join(' ')}>
                    <div className={[styles.flexRow, styles.alignCenter].join(' ')}>
                        <img src={logo_zr} alt=""></img>
                        <img src={logo_nb} alt=""></img>
                        <img src={logo_dl} alt=""></img>
                    </div>
                </a>
            </div>
        </header>
    );
}
